import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3l4cxzzyla: FaireBrandEntity = {
  token: "b_3l4cxzzyla",
  type: "brand",
  name: "THML",
  avatarUrl:
    "https://cdn.faire.com/fastly/4ed03664f594edeaa7d9b7a69092c1bf37164dce22ee536f5f2618f5925f219d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a65a82e77571e1292d950a7907f9dd124daf33a5e0f459bbb788148727630b9c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4ed03664f594edeaa7d9b7a69092c1bf37164dce22ee536f5f2618f5925f219d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a65a82e77571e1292d950a7907f9dd124daf33a5e0f459bbb788148727630b9c.jpeg",
  location: "GARDENA, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 133,
  isTopShop: true,
  isInsider: true,
  description:
    "THML Clothing, formerly know as \"Theme,\" is a women's young contemporary line based out of Los Angeles, California, The brand was launched in October of 2007. We are committed to providing our customers signature products that is unique yet fashion forward. A perfect blend of the classics and fashion savvy concepts. THML is a women’s top and dress driven brand created for women who want it all. Whether it's juggling career and family, she wants to feel and look great. Inspired by working, established women everywhere, this collection is built on fashion fundamentals sensitive to trends but not driven by them. Never fuss, always chic with a touch of bohemian flair.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:38.448Z",
    importedBy: "entity-db-cli",
  },
};
